import { API_URL } from 'consts/common.const';
import { Http } from 'services/http';

export const logout = () => {
  return Http.request({
    method: 'POST',
    url: `${API_URL}/logout`,
  });
};
